import api from '../config/api';

const productTypeService = {
  async getAll() {
    const response = await api.get('/api/admin/product-types');
    return response.data;
  },

  async create(productTypeData) {
    const response = await api.post('/api/admin/product-types/create', productTypeData);
    return response.data;
  },

  async update(id, productTypeData) {
    const response = await api.post(`/api/admin/product-types/${id}/update`, productTypeData);
    return response.data;
  },

  async delete(id) {
    const response = await api.post(`/api/admin/product-types/${id}/delete`);
    return response.data;
  },
};

export default productTypeService;
